import { render } from "./StoreFeatures.vue?vue&type=template&id=7dfbf896&scoped=true"
import script from "./StoreFeatures.vue?vue&type=script&lang=js"
export * from "./StoreFeatures.vue?vue&type=script&lang=js"

import "./StoreFeatures.vue?vue&type=style&index=0&id=7dfbf896&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dfbf896"]])

export default __exports__